export const RoutesData = [
  [
    [25.681550, -100.285992],
    [25.681647, -100.285959],
    [25.681751, -100.285876],
    [25.681838, -100.285705],
    [25.681872, -100.285511],
    [25.681840, -100.285361],
    [25.681753, -100.285192],
    [25.681678, -100.285106],
    [25.681565, -100.285026],
    [25.681383, -100.284975],
    [25.681013, -100.284994],
    [25.680907, -100.284978],
    [25.680760, -100.284903],
    [25.680760, -100.284903],
    [25.680590, -100.284693],
    [25.680523, -100.284527],
    [25.680525, -100.284321],
    [25.680557, -100.284200],
    [25.680604, -100.284089],
    [25.680686, -100.283989],
    [25.680871, -100.283867],
    [25.681016, -100.283833],
    [25.681068, -100.283801],
    [25.681092, -100.283719],
    [25.681088, -100.283638],
    [25.681054, -100.283270],
    [25.681031, -100.282659],
    [25.680638, -100.282593],
    [25.680509, -100.282603],
    [25.680313, -100.282711],
    [25.680251, -100.282813],
    [25.680221, -100.282910],
    [25.679687, -100.283134],
    [25.678849, -100.283470],
    [25.679216, -100.284736],
    [25.679250, -100.285053],
    [25.679384, -100.286264],
    [25.681550, -100.285992],
  ],
  [
    [25.681031, -100.282659],
    [25.680862, -100.279799],
    [25.680836, -100.279582],
    [25.680724, -100.279217],
    [25.680578, -100.278991],
    [25.680417, -100.278815],
    [25.680200, -100.278664],
    [25.679934, -100.278583],
    [25.679741, -100.278587],
    [25.679341, -100.278653],
    [25.679052, -100.278699],
    [25.678992, -100.278748],
    [25.678980, -100.278771],
    [25.678968, -100.278833],
    [25.679084, -100.280442],
    [25.679208, -100.281943],
    [25.679188, -100.282018],
    [25.679149, -100.282065],
    [25.678957, -100.282152],
    [25.678939, -100.282180],
    [25.678937, -100.282233],
    [25.678962, -100.282278],
    [25.679027, -100.282371],
    [25.679098, -100.282563],
    [25.679066, -100.282745],
    [25.678943, -100.282933],
    [25.678867, -100.283000],
    [25.678738, -100.283073],
    [25.678849, -100.283470],
  ],
  [
    [25.678992, -100.278748],
    [25.678823, -100.278695],
  ],
  [
    [25.682437, -100.282711],
    [25.681315, -100.282603],
    [25.681031, -100.282659],
  ],
  [
    [25.680509, -100.282603],
    [25.680499, -100.282507],
    [25.680410, -100.282507],
    [25.680229, -100.282458],
    [25.679702, -100.282418],
    [25.679027, -100.282371],
  ],
  [
    [25.680862, -100.279799],
    [25.680671, -100.279812],
    [25.680478, -100.279816],
    [25.680340, -100.279744],
    [25.680202, -100.279758],
    [25.679793, -100.280172],
    [25.679640, -100.280261],
    [25.679376, -100.280290],
    [25.679161, -100.280430],
    [25.679084, -100.280442],
  ],
  [
    [25.679687, -100.283134],
    [25.679624, -100.282855],
    [25.679619, -100.282727],
    [25.679702, -100.282418],
    [25.679755, -100.282193],
    [25.679861, -100.281938],
    [25.679987, -100.281715],
    [25.680023, -100.281611],
    [25.680043, -100.281525],
    [25.679977, -100.281480],
    [25.679925, -100.281358],
    [25.679862, -100.281189],
    [25.679827, -100.280995],
    [25.679870, -100.280810],
    [25.679905, -100.280657],
    [25.679908, -100.280596],
    [25.679830, -100.280268],
    [25.679793, -100.280172],
    [25.679600, -100.280069],
    [25.679543, -100.279990],
    [25.679549, -100.279897],
    [25.679775, -100.279494],
    [25.679797, -100.279417],
    [25.679795, -100.279358],
    [25.679704, -100.278927],
    [25.679720, -100.278855],
    [25.679771, -100.278819],
    [25.679856, -100.278797],
    [25.679960, -100.278799],
    [25.680129, -100.278894],
    [25.680486, -100.279221],
    [25.680584, -100.279376],
    [25.680614, -100.279473],
    [25.680671, -100.279812],
    [25.680679, -100.279897],
    [25.680686, -100.280039],
    [25.680649, -100.280608],
    [25.680647, -100.280953],
    [25.680623, -100.281057],
    [25.680403, -100.281381],
    [25.680368, -100.281418],
    [25.680145, -100.281521],
    [25.680043, -100.281525],
  ],
]
